import React from 'react'
import { Route, Switch } from 'react-router'
import { Container } from 'react-bootstrap'
import AdminHome from './adminHome/adminHome'
import CreateBlogPost from './createBlogPost'
import AdminUpdateProfile from './adminUpdateProfile'
import AddTikTok from './addTikTok'
import SurveyData from './SurveyData/SurveyData'
import EditBlog from './editBlog/EditBlog'
import AddRecipe from './AddRecipe/AddRecipe'

export default function AdminRouter({ match }) {
    const { path } = match
    return (
        <Container fluid>
            <Switch>
                <Route exact path={path} component={AdminHome} />
                <Route exact path={`${path}/createBlogPost`} component={CreateBlogPost} />
                <Route exact path={`${path}/updateProfile`} component={AdminUpdateProfile} />
                <Route exact path={`${path}/addTikTok`} component={AddTikTok} />
                <Route exact path={`${path}/surveyData`} component={SurveyData} />
                <Route exact path={`${path}/editblog/:id`} component={EditBlog} />
                <Route exact path={`${path}/addRecipe`} component={AddRecipe} />

            </Switch>
        </Container>
    )
}
